import { render, staticRenderFns } from "./CardBankrollReduction.vue?vue&type=template&id=18c38cee&scoped=true"
import script from "./CardBankrollReduction.js?vue&type=script&lang=js&external"
export * from "./CardBankrollReduction.js?vue&type=script&lang=js&external"
import style0 from "./CardBankrollReduction.vue?vue&type=style&index=0&id=18c38cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c38cee",
  null
  
)

export default component.exports